var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatBotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 48.75C40.3552 48.75 48.75 40.3552 48.75 30C48.75 19.6447 40.3552 11.25 30 11.25C19.6447 11.25 11.25 19.6447 11.25 30C11.25 32.9994 11.9543 35.8342 13.2065 38.3484C13.5393 39.0165 13.65 39.7802 13.4571 40.5011L12.3403 44.6751C11.8555 46.4869 13.5131 48.1444 15.325 47.6597L19.4989 46.5429C20.2199 46.35 20.9835 46.4608 21.6516 46.7934C24.1657 48.0457 27.0006 48.75 30 48.75Z",
    stroke: "#1C274C",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30H22.5169H22.5ZM29.9831 30H30H29.9831ZM37.4831 30H37.5H37.4831Z",
    fill: "#30B3D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30H22.5169M29.9831 30H30M37.4831 30H37.5",
    stroke: "#30B3D5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBotIcon);
export default __webpack_public_path__ + "static/media/chatBotIcon.af8ab9c328ab9ec54743fe553c08113c.svg";
export { ForwardRef as ReactComponent };